import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { AddOrEditGrievanceComponent } from '../_generic-components/add-or-edit-grievance/add-or-edit-grievance.component';
import { HttpService } from 'src/app/service/http/http.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class GrievanceServicesService {
    
  grievanceTypes = [  
    {key:'PERSONAL_GRIEVANCE', value:'Personal Complaints'},
    {key:'SPECIFIC_INCIDENT_GRIEVANCE', value:'Specific Incident'},
    {key:'COMMON_ISSUES_GRIEVANCE', value:'Common Issues'},
    {key:'COLLECTIVE_GRIEVANCE', value:'Collective Complaints'},
    {key:'CONTRACTUAL_VIOLATIONS_GRIEVANCE', value:'Contractual Violations'},
    {key:'POLICY_AND_PROCEDURE_GRIEVANCE', value:'Policy and Procedure Grievances'},
    {key:'SYSTEMIC_GRIEVANCE', value:'Systematic Issues'},
    {key:'WHISTLEBLOWER_GRIEVANCE', value:'Whistleblower Complaints'},
    {key:'ANY_OTHER_GRIEVANCE', value:'Any Other'}
  ];
  
  statusType: {key:string, value:string, count: number}[] = [
    { key: 'PENDING', value: 'Pending', count: 0 },
    { key: 'IN_PROGRESS', value: 'In Progress', count: 0 },
    { key: 'CLOSED', value: 'Closed', count: 0 },
  ];
  
  constructor( public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService, private getCompanyAndUsersData: GetCompanyAndUsersData, private config: Config, private httpService: HttpService, private datePipe: DatePipe) { }
  
  
  getGrevType(grevType: any){
    let returnData = '';    
    this.grievanceTypes.map((gvType: any) => {
      if(grevType === gvType.key) returnData = gvType.value;
    });
    return returnData;
  }
  
  
  onAddOrUpdateGrievanceModal(event: any){
    return this.dialog.open(AddOrEditGrievanceComponent, {
      disableClose: true,
      maxWidth: '767px',
      panelClass: 'phi_mdc_dialog__container_100',
      data: event
    });
  }
  
  
  updateCounts(tableData:any){
    this.resetCounters();
    tableData.map( (data:any) =>{
      this.statusType.map( (status:{key:string, value:string, count:number}) => {
        if(status.key === data.status){
          status.count++;
        }
      });
    });
  }
  
  
  resetCounters(){
    this.statusType.map( (status:{key:string, value:string, count:number}) => {
      status.count = 0
    });
  }
  
  
  /* Fetch, Add, Delete Grievance */
  getAllGrievanceList(tabType: string){
    this.resetCounters();
    // For Super Admin & HR
    if(this.getCompanyAndUsersData.loggedInUserType.isSuperAdmin || this.getCompanyAndUsersData.loggedInUserType.isHrAdmin) return this.httpService.callGetService(this.config.getAllGrievanceByCompanyIdAndFiscalYear+`?companyId=${this.getCompanyAndUsersData.loggedInUserCompanyID}&year=${this.getCompanyAndUsersData.currentFinancialYear}&fiscalYear=${this.getCompanyAndUsersData.loggedInCompanyFiscalyear}`);
    
    // For Employee
    if(tabType === 'addressGrievance') return this.httpService.callGetService(this.config.getGrievancesByUserOrResolver+`?companyId=${this.getCompanyAndUsersData.loggedInUserCompanyID}&resolverUserId=${this.getCompanyAndUsersData.loggedInUserId}`);
    
    return this.httpService.callGetService(this.config.getGrievancesByUserOrResolver+`?companyId=${this.getCompanyAndUsersData.loggedInUserCompanyID}&userId=${this.getCompanyAndUsersData.loggedInUserId}`);
  }
  
  addOrUpdateGrievance(data: any){
    return this.httpService.callPostService(this.config.addGrievance, data);
  }
  
  onDeleteGrievance(id:any){
    return this.httpService.callDeleteService(this.config.deleteGrievance+'/'+id);
  }
  
  updateByResolver(data: any){
    return this.httpService.callPutService(this.config.updateByResolver, data);
  }
  /* End */
  

  downloadAllOrAddressGrievance(tableRecords:any): void {
    // Step 1: Sort headers by index
    const headersArray = Object.entries(tableRecords.tableHeaders)
    .filter(([key, value]: any) => value.showInTable && key !== 'editDelete') // exclude edit/delete
    .sort((a: any, b: any) => +a[1].index - +b[1].index);
    
    const headerKeys = headersArray.map(([key]:any) => key);
    const headerNames = headersArray.map(([_, value]:any) => value.name);
    
    // Step 2: Map tableData into rows following header order
    const data = tableRecords.tableData.map((row: any, idx: number) => {
      return headerKeys.map((key) => {
        if (key === 'srNo') return idx + 1; // Auto-generate Sr No
        if (key === 'raisedDate' || key === 'resolvedDate') {
          return row[key] ? String(this.datePipe.transform(row[key], 'dd-MM-yyyy')) : '';
        }
        return row[key] ?? '';
      });
    });
    
    // Step 3: Build worksheet with headers
    const worksheet = XLSX.utils.aoa_to_sheet([headerNames, ...data]);
    
    // Step 4: Build workbook & export
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'employee_concern');
    XLSX.writeFile(workbook, 'employee_concern.xlsx');
  }
    
  
}
